import {useEffect, useRef} from 'react';
import {useIsomorphicLayoutEffect} from './useIsomorphicLayoutEffect.hook';

/**
 * 카피 : https://usehooks-ts.com/react-hook/use-interval
 * usehooks-ts 를 그대로 install 해서 사용하다가 이 라이브러리의 dist 버전이 ios 13.2 에서 동작하지 않아 필요한 것만 카피함
 */
export function useInterval(callback: () => void, delay: number | null) {
  const savedCallback = useRef(callback);
  const intervalIdRef = useRef<number>();

  // Remember the latest callback if it changes.
  useIsomorphicLayoutEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    // Don't schedule if no delay is specified.
    // Note: 0 is a valid value for delay.
    if (!delay && delay !== 0) {
      if (intervalIdRef.current) {
        window.clearInterval(intervalIdRef.current);
      }
      return;
    }

    intervalIdRef.current = window.setInterval(
      () => savedCallback.current(),
      delay
    );

    return () => {
      if (intervalIdRef.current) {
        window.clearInterval(intervalIdRef.current);
      }
    };
  }, [delay]);
}
